import React, { useState, useEffect } from 'react';
import DataTable from '../../components/DataTable';
import { attendanceAPI, employeesAPI } from '../../lib/api';

const Attendance = () => {
  const [attendance, setAttendance] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    setLoading(true);
    try {
      const [attendanceRes, employeesRes] = await Promise.all([
        attendanceAPI.getAll(),
        employeesAPI.getAll()
      ]);
      setAttendance(attendanceRes.data);
      setEmployees(employeesRes.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const getEmployeeName = (empId) => {
    const emp = employees.find(e => e.id === empId);
    return emp?.name || '-';
  };

  const columns = [
    { key: 'employee_id', label: 'Employee', render: (val) => getEmployeeName(val) },
    { key: 'date', label: 'Date', type: 'date' },
    { key: 'check_in', label: 'Check In' },
    { key: 'check_out', label: 'Check Out' },
    { key: 'status', label: 'Status', type: 'status' },
  ];

  const formFields = [
    {
      name: 'employee_id',
      label: 'Employee',
      type: 'select',
      required: true,
      options: employees.map(e => ({ value: e.id, label: e.name })),
    },
    { name: 'date', label: 'Date', type: 'date', required: true },
    { name: 'check_in', label: 'Check In Time', placeholder: '09:00' },
    { name: 'check_out', label: 'Check Out Time', placeholder: '18:00' },
    {
      name: 'status',
      label: 'Status',
      type: 'select',
      defaultValue: 'present',
      options: [
        { value: 'present', label: 'Present' },
        { value: 'absent', label: 'Absent' },
        { value: 'late', label: 'Late' },
        { value: 'half_day', label: 'Half Day' },
      ],
    },
    { name: 'notes', label: 'Notes', type: 'textarea', placeholder: 'Additional notes' },
  ];

  const handleAdd = async (data) => {
    await attendanceAPI.create(data);
    fetchData();
  };

  const handleEdit = async (id, data) => {
    await attendanceAPI.update(id, data);
    fetchData();
  };

  const handleDelete = async (id) => {
    await attendanceAPI.delete(id);
    fetchData();
  };

  return (
    <DataTable
      title="Attendance"
      description="Track employee attendance"
      data={attendance}
      columns={columns}
      formFields={formFields}
      onAdd={handleAdd}
      onEdit={handleEdit}
      onDelete={handleDelete}
      loading={loading}
    />
  );
};

export default Attendance;
